import { css } from '@emotion/react'

const logoStyle = css`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  visibility: hidden;
  background-color: white;
  height: 100%;
  width: 112px;

  &.shown {
    visibility: visible;
  }

  img {
    height: 32px;
    max-width: 100%;
    object-fit: contain;
  }
`

export { logoStyle }
